(function () {
  'use strict';

  async function handleClick(btn) {
    const container = btn.closest('[data-load-more-container]');
    if (!container) return;

    const grid =
      (container.parentElement && container.parentElement.querySelector('[data-load-more-grid]')) ||
      document.querySelector('[data-load-more-grid]');
    if (!grid) return;

    const nextUrl = container.dataset.nextUrl || '';
    if (!nextUrl || btn.disabled) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    try {
      const res = await fetch(nextUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' },
        credentials: 'same-origin',
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('[data-load-more-grid]');
      const newContainer = doc.querySelector('[data-load-more-container]');
      if (!newGrid) throw new Error('grid-not-found');

      const appended = Array.from(newGrid.children);
      const frag = document.createDocumentFragment();
      appended.forEach((node) => frag.appendChild(node));
      grid.appendChild(frag);

      try {
        history.pushState({}, '', nextUrl);
      } catch (_) {}

      const shownEl = container.querySelector('[data-load-more-shown]');
      if (shownEl && newContainer) {
        const newShown = newContainer.querySelector('[data-load-more-shown]');
        if (newShown) shownEl.textContent = newShown.textContent;
      }

      const newNext = newContainer ? newContainer.dataset.nextUrl || '' : '';
      container.dataset.nextUrl = newNext;
      if (newContainer && newContainer.dataset.currentPage) {
        container.dataset.currentPage = newContainer.dataset.currentPage;
      }

      document.dispatchEvent(
        new CustomEvent('ws:products-appended', {
          detail: { count: appended.length },
        })
      );

      const totalPages = parseInt(container.dataset.totalPages, 10) || 1;
      const currentPage = parseInt(container.dataset.currentPage, 10) || 1;
      if (!newNext || currentPage >= totalPages) {
        btn.remove();
      } else {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }
    } catch (err) {
      console.error('[ws-load-more]', err);
      btn.disabled = false;
      btn.classList.remove('is-loading');
      const statusEl = container.querySelector('[data-load-more-status]');
      if (statusEl) {
        statusEl.textContent = 'Weitere Produkte konnten nicht geladen werden. Bitte Seite neu laden.';
      }
    }
  }

  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-load-more-btn]');
    if (!btn) return;
    event.preventDefault();
    handleClick(btn);
  });
})();
